module.exports = __webpack_public_path__ + "static/media/s16.355da61a.ogg";